import { createFilterSelectList } from '@adv-frontend/filters';
import { type OpenApiLinkProductVariantRequestBaseProperties } from '#shared/api/schema';
import { getObjectEntries } from '#shared/lib/function';
import { HAS_MINIMAL_PRICE_FILTER_ID, HAS_MINIMAL_PRICE_FILTER_TITLE } from '../../constants';

export type HasMinimalPriceFilterId = Extract<
    OpenApiLinkProductVariantRequestBaseProperties['minimal_price'],
    'has_minimal_price' | 'no_minimal_price'
>;

type Item<ID extends HasMinimalPriceFilterId = HasMinimalPriceFilterId> = {
    id: ID;
    label: string;
};

const items: { [key in HasMinimalPriceFilterId]: Item<key> } = {
    has_minimal_price: {
        id: 'has_minimal_price',
        label: 'Задана минимальная цена',
    },
    no_minimal_price: {
        id: 'no_minimal_price',
        label: 'Не задана минимальная цена',
    },
} as const;

export const isHasMinimalPriceFilterId = (value?: string): value is HasMinimalPriceFilterId => {
    if (!value) {
        return false;
    }

    return Object.keys(items).includes(value);
};

export const createHasMinimalPriceFilter = () =>
    createFilterSelectList<typeof HAS_MINIMAL_PRICE_FILTER_ID, HasMinimalPriceFilterId>({
        id: HAS_MINIMAL_PRICE_FILTER_ID,
        title: HAS_MINIMAL_PRICE_FILTER_TITLE,
        isSingleSelect: true,
        items: getObjectEntries(items).map(([key, value]) => {
            return {
                value: key,
                content: value.label,
            };
        }),
    });
